import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Actions } from './components';
import useSurvey from './useSurvey';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: theme.spacing(3)
  }
}));

const SurveyActions = props => {
  const { className, ...rest } = props;
  const survey = useSurvey();
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <Actions survey={survey} showNav={true} back="/surveys/design" />
      </div>
    </div>
  );
};

export default SurveyActions;